export default {
    top_menu: [
        {name:'Lo principal',    id:0},
        {name:'Mostrar negocio', id:1},
        {name:'Cocinando',  id:2},
        {name:'Política',   id:3},
        {name:'Picante',  id:4},
        {name:'Sociedad',   id:5},
        {name:'Salud',   id:6},
    ],
    read_other: 'Lee mas',
    read_more:  'Más',
    not_found:  'Nada Encontrado',
    read_also:  'Leer también',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Reservados todos los derechos.',
    subscribe: 'Suscribir',

    thank_order: 'GRACIAS POR TU ORDEN',
    specialist_contact: 'Nuestro especialista lo contactará a la brevedad, espere nuestra llamada.',
    attention: 'Descuentos de socios:',
    hurry: '¡Date prisa, el tiempo de activación del descuento es limitado! Solo tienes <span id="time" class="time">30:00</span> minutos para elegir uno de estos productos únicos:',

    hour_ago1: "hace una hora",
    hour_ago2: "horas atras",
    hour_ago3: "horas atras",
    new_publications: "Nuevas publicaciones",
    read: "Leer",
    today_at: "Hoy a las",
    author_names: ['Elena Klimova','Maria Andreeva','Irina Klimenko'],
    main_news: "Principales noticias",
    leave_already: "¿Ya te vas? Por favor espere, hemos actualizado las noticias para usted",
    already_shared: "ya compartido"

}